// API base URLs are environment-driven (CRA reads REACT_APP_* at build time).
// Fall back to production so existing builds keep working when no .env is set.
export const beUrl = process.env.REACT_APP_BE_URL ?? "https://mymed.cz/api"
export const filesUrl = process.env.REACT_APP_FILES_URL ?? "https://mymed.cz/files"

// Public site origin (no trailing slash) — used for canonical/OG URLs and the sitemap.
export const siteUrl = (process.env.REACT_APP_SITE_URL ?? "https://mymed.cz").replace(/\/$/, "")

// Purchase gate. When false, catalog "buy" CTAs become an inert "coming soon"
// state and the checkout/payment routes redirect to the pricing page. When true,
// checkout, installments and the payment routes are live.
export const PURCHASES_ENABLED = true

// Lesson materials and question images can be either an uploaded file (a relative
// path served from filesUrl, e.g. "/uploads/x.pdf") or an external link the admin
// pasted in. Absolute URLs are used as-is; everything else is resolved against filesUrl.
export const isAbsoluteUrl = (url?: string | null) => /^https?:\/\//i.test(url ?? "");
export const resolveFileUrl = (url?: string | null) => {
    const u = url ?? "";
    if (isAbsoluteUrl(u)) return u;
    return filesUrl + (u.startsWith("/") ? u : "/" + u);
}

// Blog cover image can be: an absolute URL, an admin upload ("/uploads/..." served
// publicly by the backend's /Blog/Image endpoint), or a bundled public asset
// ("/images/..." served from the site origin). Resolve each to a loadable src.
export const resolveBlogImage = (image?: string | null) => {
    const u = image ?? "";
    if (!u) return "";
    if (isAbsoluteUrl(u)) return u;
    if (u.startsWith("/uploads")) return `${beUrl}/Blog/Image?path=${encodeURIComponent(u)}`;
    return u;
}

// Instagram thumbnail can be: an absolute URL, the backend auto-crop proxy
// (/SiteSettings/...), an admin upload (/uploads/...), or a bundled public
// asset (/images/...). Resolve each to a directly loadable src.
export const resolveInstagramImage = (image?: string | null) => {
    const u = image ?? "";
    if (!u) return "";
    if (isAbsoluteUrl(u)) return u;
    if (u.startsWith("/SiteSettings")) return beUrl + u;
    if (u.startsWith("/uploads")) return filesUrl + u;
    return u;
}
